import React, { useState } from 'react';
import VehicleTable from './VehicleData/VehicleTable';
import { useVehicleData } from '../../../../../Hooks/TT_ELD/Vehicles';
import SearchOptions from '../../../../../Utils/SearchOptions';
import {
  SearchForTruckId,
  SearchForVehicleId,
  SearchForVehicleVin,
  SearchResultForCompany,
} from '../../../../../Utils/SearchResults';
import { Button, Input, Grid, Drawer, Select, TableProps, Tabs } from 'antd';
import { useParams, useSearchParams } from 'react-router-dom';
import { AutoComplete } from 'antd';
import SearchInput from '../../../../../Utils/SearchInput';
import useRouteQuery from '../../../../../Utils/useRouterQuery';
import { CheckCircleOutlined, CloseCircleOutlined, FilterOutlined } from '@ant-design/icons';
import { useTagQuerySync } from '../../../../../Utils/useTagQuerySync';
import { isWhiteLabelAdmin } from '../../../../../Utils/whiteLabel';

const { useBreakpoint } = Grid;
const { Option } = Select;

type params = {
  readonly id: any;
};

const VehiclesCompany = () => {
  const screens = useBreakpoint();
  const xs = screens.xs;
  const sm = screens.sm;
  const md = screens.md;
  const lg = screens.lg;
  const xl = screens.xl;
  const xxl = screens.xxl;

  const isWhiteLabel = isWhiteLabelAdmin();

  const { id } = useParams<params>();
  const [skip, setSkip] = useRouteQuery('1', 'skip', String);
  const [companyId, setCompanyId] = useState<string | number>(id);
  const [companyName, setCompanyName] = useRouteQuery('', 'companyName', String);
  const [truckId, setTruckId] = useRouteQuery('', 'truckId', (v) => String(v));
  const [vehicleId, setVehicleId] = useRouteQuery('', 'vehicleId', (v) => String(v));
  const [vinId, setVinId] = useRouteQuery('', 'vinId', (v) => String(v));
  const [uid, setUid] = useRouteQuery('', 'uid', (v) => String(v));
  const [companyUID, setCompanyUID] = useRouteQuery('', 'companyUID', (v) => String(v));
  const [allowedIntegration, setAllowedIntegration] = useRouteQuery(
    '',
    'allowedIntegration',
    (v) => String(v),
  );
  const [open, setOpen] = useState(false);
  const [searchParams, setSearchParams] = useSearchParams();
  const status = searchParams.get('status') !== 'inactive';
  const setStatus = (value: boolean) => {
    const next = new URLSearchParams(searchParams);
    next.set('status', value ? 'active' : 'inactive');
    setSearchParams(next);
  };
  useTagQuerySync(
    { en_US: 'Vehicles', zh_CN: '' },
    'vehicles',
    {
      companyName,
      companyId,
      truckId,
      vehicleId,
      vinId,
      uid,
      companyUID,
      skip,
      allowedIntegration,
    },
    {
      companyName: setCompanyName,
      companyId: setCompanyId,
      truckId: setTruckId,
      vehicleId: setVehicleId,
      vinId: setVinId,
      uid: setUid,
      companyUID: setCompanyUID,
      skip: setSkip,
      allowedIntegration: setAllowedIntegration,
    },
  );

  const mappedAllowedIntegration =
    allowedIntegration === 'true'
      ? true
      : allowedIntegration === 'false'
        ? false
        : undefined;
  const { data, refetch, isLoading, isFetching } = useVehicleData(
    id,
    companyId,
    vinId,
    truckId,
    vehicleId,
    uid,
    companyUID,
    skip,
    status,
    mappedAllowedIntegration,
  );
  // const onChange = (query: any) => {
  //   setSkip(1 * parseInt(query.current));
  // };

  const onChange: TableProps<any>['onChange'] = (pagination, filters) => {
    setSkip(String(pagination.current || 1));
  };

  const handleChange = (event: string, inputName: string) => {
    const updateFunctions: Record<string, (value: string) => void> = {
      companyUID: setCompanyUID,
      uid: setUid,
    };

    if (updateFunctions[inputName]) {
      updateFunctions[inputName](event.trim());
      setSkip('1');
    }
  };

  const [optionsTruck, setOptionsTruck] = useState<Array<any>>([]);
  const [optionsVin, setOptionsVin] = useState<Array<any>>([]);
  const [optionsVehicle, setOptionsVehicle] = useState<Array<any>>([]);
  const handleSearchTruck = async (value: string) => {
    if (value) {
      let data = await SearchForTruckId(value, companyId, vinId);
      setOptionsTruck(data);
    } else {
      setOptionsTruck([]);
    }
  };
  const handleSearchVin = async (value: string) => {
    if (value) {
      let data = await SearchForVehicleVin(value, companyId, truckId);
      setOptionsVin(data);
    } else {
      setOptionsVin([]);
    }
  };
  const handleSearchVehicle = async (value: string) => {
    if (value) {
      let data = await SearchForVehicleId(value, companyId);
      setOptionsVehicle(data);
    } else {
      setOptionsVehicle([]);
    }
  };

  const handleSearchSelect =
    (setter: (val: string | number) => void, nameSetter?: (val: string) => void) =>
    (val: any, { valId }: { valId: string }) => {
      setter(valId);
      nameSetter?.(val);
      if (valId) setSkip('1');
    };

  const handleChangeTruck: any = (value: any, { valId }: { valId: string }) => {
    setTruckId(valId);
    if (valId) {
      setSkip('1');
    }
  };
  const handleChangeVin: any = (value: any, { valId }: { valId: string }) => {
    setVinId(valId);
    if (valId) {
      setSkip('1');
    }
  };
  const handleChangeVehicle: any = (value: any, { valId }: { valId: string }) => {
    setVehicleId(valId);
    if (valId) {
      setSkip('1');
    }
  };

  return (
    <div className="mainPage">
      <Tabs
        activeKey={status ? 'active' : 'inactive'}
        onChange={(key) => {
          if (key === 'active') setStatus(true);
          else if (key === 'inactive') setStatus(false);
        }}
        items={[
          {
            label: (
              <span>
                <CheckCircleOutlined style={{ marginRight: 8 }} />
                Active
              </span>
            ),
            key: 'active',
          },
          {
            label: (
              <span>
                <CloseCircleOutlined style={{ marginRight: 8 }} />
                Inactive
              </span>
            ),
            key: 'inactive',
          },
        ]}
      />

      <span style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
        {!id && (
          <SearchOptions
            value={companyName}
            SearchResult={SearchResultForCompany}
            onSelect={handleSearchSelect(setCompanyId, setCompanyName)}
            placeholder={!xxl ? 'Company' : ' Search by company'}
          />
        )}
        {sm && (
          <AutoComplete
            options={optionsTruck}
            style={{ width: 300, marginRight: '15px' }}
            onSearch={handleSearchTruck}
            onChange={handleChangeTruck}
            value={truckId}
          >
            <Input.Search
              allowClear
              placeholder={!xxl ? 'Truck' : ' Search by truck'}
              enterButton
            />
          </AutoComplete>
        )}
        {md && (
          <AutoComplete
            options={optionsVin}
            style={{ width: 300, marginRight: '15px' }}
            onSearch={handleSearchVin}
            onChange={handleChangeVin}
            value={vinId}
          >
            <Input.Search allowClear placeholder={!xxl ? 'VIN' : ' Search by VIN'} enterButton />
          </AutoComplete>
        )}
        {lg && (
          <AutoComplete
            options={optionsVehicle}
            style={{ width: 300, marginRight: '15px' }}
            onSearch={handleSearchVehicle}
            onChange={handleChangeVehicle}
            value={vehicleId}
          >
            <Input.Search
              allowClear
              placeholder={!xxl ? 'Vehicle' : ' Search by vehicle'}
              enterButton
            />
          </AutoComplete>
        )}
        {xl && !isWhiteLabel && (
          <SearchInput
            value={uid}
            placeholder={!xxl ? 'UID' : ' Search by UID'}
            onDebounceChange={(event: string) => handleChange(event, 'uid')}
          />
        )}
        {xl && !isWhiteLabel && (
          <SearchInput
            value={companyUID}
            placeholder={xxl ? 'Search by Company UID' : xl ? 'Company UID' : 'CMP UID'}
            onDebounceChange={(event: string) => handleChange(event, 'companyUID')}
          />
        )}
        {xl && (
          <Select
            allowClear
            placeholder="Data Sharing"
            value={allowedIntegration || undefined}
            onChange={(value: string | undefined) => {
              setAllowedIntegration(value === 'all' ? '' : value || '');
              setSkip('1');
            }}
            style={{ width: 170, marginRight: 15 }}
          >
            <Option value="all">All</Option>
            <Option value="true">Allowed</Option>
            <Option value="false">Not Allowed</Option>
          </Select>
        )}
        <span style={{ display: 'flex', gap: '10px' }}>
          {!xl && (
            <Button size={'large'} onClick={() => setOpen(true)}>
              <FilterOutlined />
            </Button>
          )}
          {!xs && (
            <Button size={'large'} onClick={() => refetch()}>
              Refresh
            </Button>
          )}
        </span>
      </span>
      <>
        {!xl && (
          <Drawer
            title={null}
            closable={false}
            placement="bottom"
            onClose={() => setOpen(false)}
            open={open}
            height={md ? 90 : sm ? 130 : 280}
          >
            <span className="page-filter-search">
              {!sm && (
                <AutoComplete
                  options={optionsTruck}
                  style={{ width: '100%' }}
                  onSearch={handleSearchTruck}
                  onChange={handleChangeTruck}
                  value={truckId}
                >
                  <Input.Search allowClear placeholder="Search by truck" enterButton />
                </AutoComplete>
              )}
              {!md && (
                <AutoComplete
                  options={optionsVin}
                  style={{ width: '100%', marginRight: '15px' }}
                  onSearch={handleSearchVin}
                  onChange={handleChangeVin}
                  value={vinId}
                >
                  <Input.Search allowClear placeholder=" Search by VIN" enterButton />
                </AutoComplete>
              )}
              {!lg && (
                <AutoComplete
                  options={optionsVehicle}
                  style={{ width: '100%', marginRight: '15px' }}
                  onSearch={handleSearchVehicle}
                  onChange={handleChangeVehicle}
                  value={vehicleId}
                >
                  <Input.Search allowClear placeholder=" Search by vehicle" enterButton />
                </AutoComplete>
              )}
              {!xl && !isWhiteLabel && (
                <SearchInput
                  value={uid}
                  placeholder=" Search by UID"
                  onDebounceChange={(event: string) => handleChange(event, 'uid')}
                  searchWidth={'100%'}
                />
              )}
              {!xl && !isWhiteLabel && (
                <SearchInput
                  value={companyUID}
                  placeholder="Search by Company UID"
                  onDebounceChange={(event: string) => handleChange(event, 'companyUID')}
                  searchWidth={'100%'}
                />
              )}
              {!xl && (
                <Select
                  allowClear
                  placeholder="Data Sharing"
                  value={allowedIntegration || undefined}
                  onChange={(value: string | undefined) => {
                    setAllowedIntegration(value === 'all' ? '' : value || '');
                    setSkip('1');
                  }}
                  style={{ width: '100%' }}
                >
                  <Option value="all">All</Option>
                  <Option value="true">Allowed</Option>
                  <Option value="false">Not Allowed</Option>
                </Select>
              )}
            </span>
          </Drawer>
        )}
      </>
      <VehicleTable
        vehicle={data?.data}
        total={data?.count}
        onChange={onChange}
        isLoading={isLoading}
        isFetching={isFetching}
        skip={skip}
      />
    </div>
  );
};

export default VehiclesCompany;
